/**
 * SUMMARY_ITEM_ID — identifiers for all possible items in the ProductView SUMMARY pane.
 *
 * Each ID maps to one entry in SUMMARY_ITEM_REGISTRY (see utils/summaryItems.js).
 * Adding a new displayable field: add a constant here + a registry entry there.
 */
export const SUMMARY_ITEM_ID = {
  // INVESTMENT:      'investment',
  // STAGE:      'stage',
  BUILDING:      'building',
  GATE:          'gate',
  FLOOR:         'floor',
  ROOMS:         'rooms',
  AREA:          'area',
  // LEVELS`:        'levels',
  // LOT_AREA`:        'lot_area',
  // AREA_PERCENTILE: 'area_percentile',
  // HEIGHT:        'height',
  EXPOSITION:    'exposition',
  OUTDOOR_AREAS: 'outdoor_areas',
  // SPECIAL_AREAS: 'special_areas',
  INSOLATION_HOURS:    'insolation_hours',
  INSOLATION_RANGE:    'insolation_range',
  TURNKEY_STYLE: 'turnkey_style',
  // ENERGY_CLASS:    'energy_class',
  // ENERGY_USEFUL:   'energy_useful', //EU
  // ENERGY_FINAL:    'energy_final', //EK
  // ENERGY_PRIMARY:  'energy_primary' //EP
  // ENERGY_RENEWABLE_SHARE: 'energy_renewable_share', //Uoze
  // ENERGY_CO2_EMISSIONS: 'energy_co2_emissions' //Eco2
  // ENERGY_HEATING_COST_NOW: 'energy_heating_cost_now',
  // ENERGY_HEATING_COST_10Y: 'energy_heating_cost_10y',
}